/** Mirror of free-tier limits (see functions/subscriptionTierLimits.ts). */
export const FREE_MANUAL_SNIPPET_CREATIONS_PER_MONTH = 10;
export const FREE_COOKBOOK_CREATIONS_PER_MONTH = 2;
